export const DEFAULT_SERIAL_MOTOR = 'NOREPORTA';

export default DEFAULT_SERIAL_MOTOR;
